import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MapLayerData } from "../services/types";
import MapItemDetailSkeleton from "../components/skeletons/MapItemDetailSkeleton";
import MapItemMatrixUI from "../components/layers/MapItemMatrixUI";
import MapItemDetailUI from "../components/layers/MapItemDetailUI";

const SlideoutMapItemDetails = () => {
    const [layerData, setLayerData] = useState<MapLayerData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const [searchParams] = useSearchParams();
    
    // Set layerId, point id, and partnerId from search params    
    const layerId = searchParams.get('layerId');
    const pointId = searchParams.get('id');

    // Initialize layer summary info
    const summary = layerData?.summary[0];

    // Define current point layer item based on search params
    const items = layerData?.items;
    const item = items?.find(item => Number(item.id) === Number(pointId));

    console.log('item:', item);

    const name = item?.name;
    const description = item?.description;
    const category = item?.category;
    const value = item?.value;
    const lat = item?.latitude;
    const long = item?.longitude;
    const attributes = item?.attributes || [];

    // Fetch layer details, items, and summary when layerId changes
    useEffect(() => {
        if (!layerId) return;
            
        // Set loading state and clear out previous data
        setLoading(true);
        setLayerData(null);

        const fetchLayerData = async () => {
            try {
                const response = await fetch(
                `${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getlayeritems?layerId=${layerId}`,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                }
                );
                if (!response.ok) throw new Error('Failed to fetch layer items');

                const data = await response.json();
                setLayerData(data);
            } catch (error) {
                console.error(`Error fetching layer data for layer ${layerId}:`, error);
                setLayerData(null);
            } finally {
                setLoading(false);
            }
        };
  
        fetchLayerData();
    }, [layerId]);

    const parsedLayerId = Number(layerId);

    // Show loading animation if the layers are currently loading
    if (loading || !item) return <MapItemDetailSkeleton layerId={parsedLayerId}/>

    return parsedLayerId === 150 ? (
        <MapItemDetailUI
            key={`${layerId}-${pointId}`}
            item={item}
            summary={summary}
        />
    ) : (
        <MapItemMatrixUI
            key={`${layerId}-${pointId}`}
            name={name || 'TBD'}
            description={description}
            category={category}
            value={value}
            lat={lat}
            long={long}
            attributes={attributes}
            summary={summary}
        />
    );
};
  
export default SlideoutMapItemDetails;